<template>
  <div class="wrap" id="i-detail-wrap">
    <div style="width:100%" v-if="mounted">
      <div :class="[child == true ? 'header-individual-child' : header_notification ? 'header-individual full header-notification-space' : 'header-individual full']">
        <div class="search-form">
          <div class="header-tabs" @click="tabs != 'summary' ? changeTab('summary') : ''" :class="tabs == 'summary' ? 'active' : ''">サマリー</div>
          <div class="header-tabs" @click="tabs != 'analysis' ? changeTab('analysis') : ''" :class="tabs == 'analysis' ? 'active' : ''">分析</div>
          <div class="header-tabs" @click="tabs != 'post' ? changeTab('post') : ''" :class="tabs == 'post' ? 'active' : ''">動画</div>
          <div class="header-tabs" @click="tabs != 'note' ? changeTab('note') : ''" :class="tabs == 'note' ? 'active' : ''">ノート</div>
          <!-- <div class="header-divider"></div> -->
          <otherSNS :own_id="profile_data.channel_id" :other_sns="profile_data.other_sns" :similar_data="similar_data" :parent_component="parent_component" :child="child" />
        </div>
        <div class="flex"></div>
        <div class="i-detail-similar-button-wrap pointer" v-if="similar_data && !similar_loading" @click="scrollBottom()">
          <div class="i-detail-similar-icon" v-for="similar in similar_account" :key="similar.channel_id">
            <el-image :src="similar.profile_picture_url" class="i-detail-header-sns-img" style="border:1px solid #fff">
              <div slot="error" class="data-table-profile-noimg">NO<br />IMAGE</div>
            </el-image>
          </div>
          <div class="i-detail-header-similar-description">類似<br />アカウント</div>
        </div>
        <div v-if="similar_loading" class="i-detail-similar-button-wrap pointer">
          <div v-for="n in 5" :key="n">
            <div class="i-detail-similar-icon"><div class="i-detail-header-sns-img data-table-profile-noimg w-border"></div></div>
          </div>
          <div class="i-detail-header-similar-description">類似<br />アカウント</div>
        </div>
      </div>

      <div class="i-detail-wrap" v-show="!loading" :class="child == true ? 'child' : ''">
        <div class="i-detail-user-page">
          <!-- プロフィール部分 -->
          <div class="profile" :style="tabs == 'post' || tabs == 'note' ? 'margin-bottom:0px' : ''">
            <div class="profile-left">
              <div class="profile-img-area" :class="tabs != 'summary' ? 'minimize' : ''">
                <div class="profile-img-wrap">
                  <el-tooltip placement="bottom">
                    <div slot="content" style="font-size:10px">
                      お気に入り<span>{{ profile_data.favorite == 0 ? "に追加" : "から削除" }}</span>
                    </div>
                    <div class="profile-img-favorite" :class="[tabs != 'summary' ? 'minimize' : '', profile_data.favorite == 0 ? 'off' : '']" @click="favorite">
                      <font-awesome-icon icon="star" />
                    </div>
                  </el-tooltip>
                  <el-image class="profile_img" :class="tabs != 'summary' ? 'minimize' : ''" :src="profile_data.thumbnails_medium">
                    <div slot="error" class="data-table-profile-noimg">NO<br />IMAGE</div>
                  </el-image>
                </div>
              </div>
              <div class="profile-gender-area" v-if="tabs == 'summary' || tabs == 'analysis'">
                <div class="profile-title">
                  チャンネル登録者の男女比率&nbsp;
                  <el-tooltip placement="top">
                    <div slot="content">AIにより算出したフォロワーの男女比です。<br />実際の数値とは異なる場合があります。</div>
                    <span><font-awesome-icon icon="question-circle" style="margin-left:3px; color:#666;"/></span>
                  </el-tooltip>
                </div>
                <div class="gender-bar" v-if="profile_data.female_ratio && !(profile_data.female_ratio == 0 && profile_data.male_ratio == 0)">
                  <div class="female-box" :style="{ width: profile_data.female_ratio + '%' }">
                    <font-awesome-icon icon="female" style="margin-right:6px" />
                    <div class="female-ratio">{{ profile_data.female_ratio }}</div>
                    %
                  </div>
                  <div class="male-box" :style="{ width: profile_data.male_ratio + '%' }">
                    <div class="male-ratio">{{ profile_data.male_ratio }}</div>
                    %
                    <font-awesome-icon icon="male" style="margin-left:6px" />
                  </div>
                </div>
                <div class="no-data" v-else>データがありません</div>
                <div class="profile-gender-detail-wrap" v-if="youtubeAudienceRows.length">
                  <div class="profile-gender-detail-female" :style="'width:' + profile_data.female_ratio + '%'">
                    <el-tooltip v-for="(row, idx) in youtubeAudienceRows" :key="'yf-' + idx + '-' + row.name">
                      <div slot="content">
                        <div style="margin-bottom: 3px;"><font-awesome-icon icon="female" style="margin-right:6px" />{{ row.female.name }}</div>
                        <div>{{ row.female.data !== null ? row.female.data + '%' : '—' }}</div>
                      </div>
                      <div class="female-box detail" :style="youtubeAudienceBarStyle(row.female, 'female')"></div>
                    </el-tooltip>
                  </div>
                  <div class="profile-gender-detail-center" :style="profile_data.male_ratio > profile_data.female_ratio ? 'right:0px' : ''">
                    <div v-for="(row, idx) in youtubeAudienceRows" :key="'yc-' + idx + '-' + row.name" class="profile-gender-detail-title">{{ row.name }}</div>
                  </div>
                  <div class="profile-gender-detail-male" :style="'width:' + profile_data.male_ratio + '%'">
                    <el-tooltip v-for="(row, idx) in youtubeAudienceRows" :key="'ym-' + idx + '-' + row.name">
                      <div slot="content">
                        <div style="margin-bottom: 3px;"><font-awesome-icon icon="male" style="margin-right:6px" />{{ row.male.name }}</div>
                        <div>{{ row.male.data !== null ? row.male.data + '%' : '—' }}</div>
                      </div>
                      <div class="male-box detail" :style="youtubeAudienceBarStyle(row.male, 'male')"></div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <div class="profile-category" v-show="tabs == 'summary' || tabs == 'post'">
                <div class="profile-title">
                  関連カテゴリ&nbsp;
                  <el-tooltip placement="top" content="YouTubeで定義されているカテゴリです。">
                    <font-awesome-icon icon="question-circle" style="margin-left:3px; color:#666;" />
                  </el-tooltip>
                </div>
                <div class="category-box-wrap" v-if="profile_data.topicIds">
                  <div class="category-box pointer" v-for="category in profile_data.topicIds" v-bind:key="category.id" @click="searchMedia('category', category.topic_name)">
                    <font-awesome-icon icon="tag" style="margin-right:3px; font-size:10px" />
                    &nbsp;{{ category.topic_name }}
                  </div>
                </div>
              </div>
            </div>
            <div class="profile-right">
              <div class="profile-username">
                <div class="profile-username-box accountname" :class="tabs != 'summary' ? 'minimize' : ''">
                  {{ profile_data.channel_name }}
                  <div class="profile-sort-keyword-wrap">
                    <div v-if="search_type != 'all' && tabs == 'post'" class="profile-sort-keyword">
                      「{{ search_keyword }}」の投稿
                      <font-awesome-icon :icon="['fas', 'times-circle']" style="margin-left: 5px; color:#333" class="pointer" @click="searchMedia('all', '')" />
                    </div>
                    <div v-if="sort_period != 'all' && tabs == 'post'" class="profile-sort-keyword">
                      {{ sort_period == "1month" ? "直近30日" : sort_period == "3month" ? "直近90日" : sort_period == "6month" ? "直近180日" : "" }}の投稿
                      <font-awesome-icon :icon="['fas', 'times-circle']" style="margin-left: 5px; color:#333" class="pointer" @click="sortMediaBy('timestamp', 'all', '投稿日が新しい順')" />
                    </div>
                  </div>
                </div>

                <div class="profile-username-box">
                  <addListDetail
                    ref="add_list_detail"
                    :influencer_id="profile_data.channel_id"
                    :list_count="profile_data.list_count"
                    :add_delete_index="add_delete_index"
                    :add_delete_loading="add_delete_loading"
                    :sns_type="'youtube'"
                    @addInfluencer="addInfluencer"
                    @deleteInfluencer="deleteInfluencer"
                  />
                  <el-tooltip placement="top" content="YouTubeでアカウントを表示">
                    <el-button type="info" style="margin-left:10px;" @click="openYouTube()">
                      <font-awesome-icon :icon="['fab', 'youtube']" />
                    </el-button>
                  </el-tooltip>
                </div>
              </div>
              <div class="profile_follower" v-if="tabs == 'summary' || tabs == 'analysis'">
                <div class="profile_num followers">
                  <div class="num_title">チャンネル登録者</div>
                  <div v-if="profile_data.hiddenSubscriberCount == 1"><span class="num"></span>非公開</div>
                  <div v-else>
                    <span class="num">{{ profile_data.subscriberCount_tt }}</span
                    >万人
                  </div>
                  <div class="num_bar">
                    <div class="num_bar_power" :style="'width:' + (profile_data.subscriberCount_tt / 30) * 100 + '%'" :class="profile_data.subscriberCount_tt < 1 ? 'danger' : ''"></div>
                  </div>
                </div>
                <div class="profile_num">
                  <div class="num_title">
                    平均EGR
                    <el-tooltip placement="top">
                      <div slot="content">直近90日の平均エンゲージメント率(EngagementRate)を示しています。<br />高評価数とコメント数の合計をチャンネル登録者数で割った比率です。</div>
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div v-if="profile_data.hiddenSubscriberCount == 1"><span class="num"></span>-</div>
                  <div v-else>
                    <span class="num">{{ profile_data.average_engagementRate_subscriber_3month }}</span
                    >%
                  </div>
                  <div class="num_bar">
                    <div
                        class="num_bar_power"
                        :style="'width:' + (profile_data.average_engagementRate_subscriber_3month * 100) / 3 + '%'"
                        :class="profile_data.average_engagementRate_subscriber_3month < 1 ? 'danger' : ''"
                    ></div>
                  </div>
                </div>
                <div class="profile_num">
                  <div class="num_title">
                    平均高評価数
                    <el-tooltip placement="top">
                      <div slot="content">直近90日の1投稿あたりの平均高評価数を示しています。</div>
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span class="num">{{ averageLikeFormat(profile_data.average_likeCount_3month) }}</span>
                    <span>{{ profile_data.average_likeCount_3month >= 10000 ? "万件" : "件" }}</span>
                  </div>
                  <div class="num_bar">
                    <div class="num_bar_power"
                         :style="{width: Math.min(100, Math.max(0, ((Number(profile_data.average_likeCount_3month) || 0) * 100) / 2000)) + '%'}"
                         :class="((Number(profile_data.average_likeCount_3month) || 0) < 200 ? 'danger' : '')">
                    </div>
                  </div>
                </div>
                <div class="profile_num">
                  <div class="num_title">
                    平均コメント数
                    <el-tooltip placement="top">
                      <div slot="content">直近90日の平均コメント数です。</div>
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span class="num">{{ profile_data.average_commentCount_3month }}</span
                    >件
                  </div>
                  <div class="num_bar">
                    <div
                        class="num_bar_power"
                        :style="'width:' + profile_data.average_commentCount_3month / 3 + '%'"
                        :class="profile_data.average_commentCount_3month < 200 ? (profile_data.average_commentCount_3month < 50 ? 'danger' : 'medium') : ''"
                    ></div>
                  </div>
                </div>
                <div class="profile_num followers">
                  <div class="num_title">
                    総視聴回数
                  </div>
                  <div>
                    <span class="num">{{ profile_data.viewCount | viewcount }}</span>
                    <span>{{ profile_data.viewCount > 9999 ? "億回" : "万回" }}</span>
                    <div class="num_bar">
                      <div class="num_bar_power" :style="'width:' + profile_data.viewCount * 3 + '%'" :class="profile_data.viewCount < 5 ? 'danger' : ''"></div>
                    </div>
                  </div>
                </div>
                <div class="profile_num">
                  <div class="num_title">
                    平均視聴率
                    <el-tooltip placement="top">
                      <div slot="content">
                        直近90日の平均視聴率を示しています。
                        <br />直近90日の1投稿あたりの平均視聴数をチャンネル登録者数で割った比率です。
                      </div>
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>

                  <div class="reel_average_video_play_count">
                    <!-- 長尺 -->
                    <div class="reel_num_total">
                      長尺
                      <div>
                        <template v-if="!isMissingNumber(profile_data.average_viewRate_long_3month)">
                          <span class="num">{{ profile_data.average_viewRate_long_3month }}</span><span class="unit-compact">%</span>
                        </template>
                        <template v-else>
                          <span class="num">-</span>
                        </template>
                      </div>
                      <div class="num_bar">
                        <div
                            class="num_bar_power"
                            :style="'width:' + (isMissingNumber(profile_data.average_viewRate_long_3month) ? 0 : profile_data.average_viewRate_long_3month) + '%'"
                            :class="profile_data.average_viewRate_long_3month < 20 ? 'danger' : ''"
                        ></div>
                      </div>
                    </div>

                    <!-- ｼｮｰﾄ動画 -->
                    <div class="reel_num_total">
                      ｼｮｰﾄ動画
                      <div>
                        <template v-if="!isMissingNumber(profile_data.average_viewRate_short_3month)">
                          <span class="num">{{ profile_data.average_viewRate_short_3month }}</span><span class="unit-compact">%</span>
                        </template>
                        <template v-else>
                          <span class="num">-</span>
                        </template>
                      </div>
                      <div class="num_bar">
                        <div
                            class="num_bar_power"
                            :style="'width:' + (isMissingNumber(profile_data.average_viewRate_short_3month) ? 0 : profile_data.average_viewRate_short_3month) + '%'"
                            :class="profile_data.average_viewRate_short_3month < 20 ? 'danger' : ''"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="profile_num avg_view_count">
                  <div class="num_title">
                    平均視聴回数
                    <el-tooltip placement="top" content="直近90日の1投稿あたりの平均視聴回数を示しています。">
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>

                  <div class="reel_average_video_play_count">
                    <!-- 長尺 -->
                    <div class="reel_num_total">
                      長尺
                      <div>
                        <template v-if="!isMissingNumber(profile_data.average_viewCount_long_3month)">
                          <span class="num">{{ formatViewCountNumber(profile_data.average_viewCount_long_3month) }}</span>
                          <span class="unit-compact">{{ formatViewCountUnit(profile_data.average_viewCount_long_3month) }}</span>
                        </template>
                        <template v-else>
                          <span class="num">-</span>
                        </template>
                      </div>
                      <div class="num_bar">
                        <div
                            class="num_bar_power"
                            :style="{width: Math.min(100, Math.max(0, (isMissingNumber(profile_data.average_viewCount_long_3month) ? 0 : Number(profile_data.average_viewCount_long_3month)) * 3)) + '%'}"
                            :class="(Number(profile_data.average_viewCount_long_3month) || 0) < 5 ? 'danger' : ''"
                        ></div>
                      </div>
                    </div>

                    <!-- ｼｮｰﾄ動画 -->
                    <div class="reel_num_total">
                      ｼｮｰﾄ動画
                      <div>
                        <template v-if="!isMissingNumber(profile_data.average_viewCount_short_3month)">
                          <span class="num">{{ formatViewCountNumber(profile_data.average_viewCount_short_3month) }}</span>
                          <span class="unit-compact">{{ formatViewCountUnit(profile_data.average_viewCount_short_3month) }}</span>
                        </template>
                        <template v-else>
                          <span class="num">-</span>
                        </template>
                      </div>
                      <div class="num_bar">
                        <div
                            class="num_bar_power"
                            :style="{width: Math.min(100, Math.max(0, (isMissingNumber(profile_data.average_viewCount_short_3month) ? 0 : Number(profile_data.average_viewCount_short_3month)) * 3)) + '%'}"
                            :class="(Number(profile_data.average_viewCount_short_3month) || 0) < 5 ? 'danger' : ''"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="profile_num pr_rate">
                  <div class="num_title">投稿動画数</div>
                  <div>
                    <span class="num">{{ profile_data.videoCount }}</span
                    >本
                  </div>
                  <div class="num_bar">
                    <div class="num_bar_power" :style="'width:' + profile_data.videoCount + '%'" :class="profile_data.videoCount < 25 ? 'danger' : ''"></div>
                  </div>
                </div>
                <div class="profile_num pr_rate">
                  <div class="num_title">
                    PR率
                    <el-tooltip placement="top">
                      <div slot="content">直近90日の投稿に占めるPR投稿の比率です。<br />20%を超えるとPR・広告色が強い印象を受ける可能性が高まります。</div>
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>

                  <div class="reel_average_video_play_count">
                    <!-- 長尺 -->
                    <div class="reel_num_total">
                      長尺
                      <div>
                        <template v-if="!isMissingNumber(profile_data.prRate_long_3month)">
                          <span class="num">{{ Number(profile_data.prRate_long_3month) }}</span><span class="unit-compact">%</span>
                        </template>
                        <template v-else>
                          <span class="num">-</span>
                        </template>
                      </div>
                      <div class="num_bar">
                        <div
                            class="num_bar_power"
                            :style="{width: Math.min(100, Math.max(0, isMissingNumber(profile_data.prRate_long_3month) ? 0 : Number(profile_data.prRate_long_3month))) + '%'}"
                            :class="(Number(profile_data.prRate_long_3month) || 0) > 15 ? 'danger' : ''"
                        ></div>
                      </div>
                    </div>

                    <!-- ｼｮｰﾄ動画 -->
                    <div class="reel_num_total">
                      ｼｮｰﾄ動画
                      <div>
                        <template v-if="!isMissingNumber(profile_data.prRate_short_3month)">
                          <span class="num">{{ Number(profile_data.prRate_short_3month) }}</span><span class="unit-compact">%</span>
                        </template>
                        <template v-else>
                          <span class="num">-</span>
                        </template>
                      </div>
                      <div class="num_bar">
                        <div
                            class="num_bar_power"
                            :style="{width: Math.min(100, Math.max(0, isMissingNumber(profile_data.prRate_short_3month) ? 0 : Number(profile_data.prRate_short_3month))) + '%'}"
                            :class="(Number(profile_data.prRate_short_3month) || 0) > 15 ? 'danger' : ''"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="profile_num followers" v-if="tabs == 'analysis'">
                  <div class="num_title">
                    登録者増加率
                    <el-tooltip placement="top" content="直近90日間におけるチャンネル登録者の増加率を示しています。">
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span v-if="profile_data.subscriber_growth_rate_90 > 0">+ </span>
                    <span class="num">{{ profile_data.subscriber_growth_rate_90 | growthrate }}</span
                    >%
                    <div class="num_bar">
                      <div class="num_bar_power" :style="'width:' + profile_data.subscriber_growth_rate_90 * 10 + '%'" :class="profile_data.subscriber_growth_rate_90 < 0 ? 'danger' : ''"></div>
                    </div>
                  </div>
                </div>
                <div class="profile_num" v-if="tabs == 'analysis'">
                  <div class="num_title">
                    視聴数増加率
                    <el-tooltip placement="top" content="直近90日間における総再生回数の増加率を示しています。">
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span v-if="profile_data.viewCount_growth_rate_90 > 0">+ </span>
                    <span class="num">{{ profile_data.viewCount_growth_rate_90 | growthrate }}</span
                    >%
                    <div class="num_bar">
                      <div class="num_bar_power" :style="'width:' + profile_data.viewCount_growth_rate_90 * 10 + '%'" :class="profile_data.viewCount_growth_rate_90 < 0 ? 'danger' : ''"></div>
                    </div>
                  </div>
                </div>
                <div class="profile_num" v-if="tabs == 'analysis'">
                  <div class="num_title">
                    投稿頻度
                    <el-tooltip placement="top" content="直近90日の平均投稿頻度です。">
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span class="num">{{ profile_data.average_postCount_week }}</span
                    >/週
                    <div class="num_bar">
                      <div class="num_bar_power" :style="'width:' + (profile_data.average_postCount_week * 100) / 7 + '%'" :class="profile_data.average_postCount_week < 1 ? 'danger' : ''"></div>
                    </div>
                  </div>
                </div>
                <div class="profile_num" v-if="tabs == 'analysis'">
                  <div class="num_title">平均動画時間</div>
                  <div v-if="activate > 10">
                    <span class="num">{{ profile_data.average_duration }}</span
                    >分
                    <div class="num_bar">
                      <div class="num_bar_power" :style="'width:' + profile_data.average_duration * 7 + '%'" :class="profile_data.average_duration < 1 ? 'danger' : ''"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="profile-name-area" v-if="tabs == 'summary'">
                <div class="profile_name">
                  <div class="profile-feature" v-if="profile_data.gender == '男性' || profile_data.gender == '女性' || profile_data.gender == 'グループ'">
                    <span v-if="profile_data.gender == '女性'"><font-awesome-icon :icon="['fas', 'female']" style="color:#f56c6c; margin-right: 5px;" />女性</span>
                    <span v-if="profile_data.gender == '男性'"><font-awesome-icon :icon="['fas', 'male']" style="color:#0095f6; margin-right: 5px;" />男性</span>
                    <span v-if="profile_data.gender == 'グループ'"><font-awesome-icon :icon="['fas', 'user-group']" style="color:#aaa; margin-right: 5px;" />グループ</span>
                  </div>
                </div>

                <div class="profile_bio" :class="omission ? 'omission' : ''" v-if="tabs == 'summary'">
                  <pre>{{ profile_data.description }}</pre>
                  <div class="pointer omission_button" @click="omission = !omission" v-if="omission">もっと見る</div>
                  <div class="pointer omission_button" @click="omission = !omission" v-else>閉じる</div>
                </div>
              </div>
            </div>
          </div>

          <div class="search-form-youtube" v-if="tabs == 'post'">
            <div class="header-search-wrap instagram" style="width: 180px; margin-right: 10px" :style="inputfocus ? 'width: 100%' : ''">
              <font-awesome-icon :icon="['fas', 'search']" style="font-size:16px; color:#aaa; margin-right:10px" />
              <postSearchInput :inputfocus.sync="inputfocus" :inputkeyword.sync="inputkeyword" @searchKeyword="searchMedia" />
            </div>
            <div class="flex-space"></div>
            <div v-if="tabs == 'post' && video_count > 0">
              <el-pagination
                @current-change="pageChange"
                :current-page.sync="currentPage"
                background
                layout="prev, pager, next"
                :total="video_count"
                :page-size="pagesize"
                :pager-count="5"
                small
              ></el-pagination>
            </div>
            <el-checkbox :value="search_type == 'pr'" @change="search_type == 'pr' ? searchMedia('all', '') : searchMedia('pr', 'PR投稿')" style="display:flex; align-items:center;">
              <el-tooltip placement="bottom" content="「提供」「PR」などのPR表記のある投稿のみを表示します。">
                <span style="font-size:11px; color:#666; ">PR投稿のみを表示</span>
              </el-tooltip>
            </el-checkbox>
            <el-dropdown trigger="click" style="margin-left: 20px">
              <el-button type="info" class="report-media-sort-button">
                {{ media_sort }}
                <font-awesome-icon :icon="['fas', 'caret-down']" style="margin-left: 5px" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :class="media_sort == '投稿日が新しい順'" :disabled="media_sort == '投稿日が新しい順'" @click.native="sortMediaBy('timestamp', 'all', '投稿日が新しい順')"
                  >投稿日が新しい順</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == '再生数が多い順(直近30日)' ? 'assign' : ''"
                  :disabled="media_sort == '再生数が多い順(直近30日)'"
                  @click.native="sortMediaBy('viewCount', '1month', '再生数が多い順(直近30日)')"
                  >再生数が多い順(直近30日)</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == '再生数が多い順(直近90日)' ? 'assign' : ''"
                  :disabled="media_sort == '再生数が多い順(直近90日)'"
                  @click.native="sortMediaBy('viewCount', '3month', '再生数が多い順(直近90日)')"
                  >再生数が多い順(直近90日)</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == '再生数が多い順(直近180日)' ? 'assign' : ''"
                  :disabled="media_sort == '再生数が多い順(直近180日)'"
                  @click.native="sortMediaBy('viewCount', '6month', '再生数が多い順(直近180日)')"
                  >再生数が多い順(直近180日)</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == '再生数が多い順(全期間)' ? 'assign' : ''"
                  :disabled="media_sort == '再生数が多い順(全期間)'"
                  @click.native="sortMediaBy('viewCount', 'all', '再生数が多い順(全期間)')"
                  >再生数が多い順(全期間)</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == 'エンゲージメントが多い順(直近30日)' ? 'assign' : ''"
                  :disabled="media_sort == 'エンゲージメントが多い順(直近30日)'"
                  @click.native="sortMediaBy('engagementCount', '1month', 'エンゲージメントが多い順(直近30日)')"
                  >エンゲージメントが多い順(直近30日)</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == 'エンゲージメントが多い順(直近90日)' ? 'assign' : ''"
                  :disabled="media_sort == 'エンゲージメントが多い順(直近90日)'"
                  @click.native="sortMediaBy('engagementCount', '3month', 'エンゲージメントが多い順(直近90日)')"
                  >エンゲージメントが多い順(直近90日)</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == 'エンゲージメントが多い順(直近180日)' ? 'assign' : ''"
                  :disabled="media_sort == 'エンゲージメントが多い順(直近180日)'"
                  @click.native="sortMediaBy('engagementCount', '6month', 'エンゲージメントが多い順(直近180日)')"
                  >エンゲージメントが多い順(直近180日)</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == 'エンゲージメントが多い順(全期間)' ? 'assign' : ''"
                  :disabled="media_sort == 'エンゲージメントが多い順(全期間)'"
                  @click.native="sortMediaBy('engagementCount', 'all', 'エンゲージメントが多い順(全期間)')"
                  >エンゲージメントが多い順(全期間)</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <!-- 投稿リスト部分 -->
          <div v-if="video_count > 0">
            <ul class="gallery-wrap" v-show="profile_data.viewCount > 0 && (tabs == 'summary' || tabs == 'post')">
              <li class="gallery_item youtube" v-for="(video_data, index) in video_data" :key="video_data.id">
                <div class="gallery_item_img_wrap pointer">
                  <div class="gallery_item_duration">{{ video_data.duration }}</div>
                  <div class="pr_type" v-show="video_data.pr_flag">
                    <div class="pr_tag">PR</div>
                  </div>
                  <div class="shorts" v-show="video_data.shorts">
                    <div class="shorts_tag">
                      <img src="../../assets/yt_shorts.png" />
                    </div>
                  </div>
                  <img class="gallery_img" :src="'https://i.ytimg.com/vi/' + video_data.video_id + '/mqdefault.jpg?' + actionId" @load="imgLoaded" @error="imgError(index)" @click="detail(index)" />
                </div>
                <div class="gallery_description_area">
                  <div class="gallery_description_title">
                    <span
                      class="caption-in title"
                      v-html="$options.filters.searchHighlight(video_data.title, search_type == 'keyword' ? search_keyword : '', search_type == 'pr' ? true : false)"
                    ></span>
                  </div>
                  <div class="gallery_description_indicator_wrap">
                    <div class="gallery_description_indicator">
                      <el-tooltip content="視聴数">
                        <span>
                          <font-awesome-icon icon="eye" style="margin-right:2px" />
                          {{ video_data.viewCount | addComma }}
                        </span>
                      </el-tooltip>
                      <el-tooltip content="コメント数">
                        <span>
                          <font-awesome-icon :icon="['far', 'comment']" style="margin-right:2px; margin-left:10px" />
                          {{ video_data.commentCount }}
                        </span>
                      </el-tooltip>
                      <el-tooltip content="エンゲージメント率">
                        <span>
                          <font-awesome-icon icon="thumbs-up" style="margin-right:2px; margin-left:10px" />
                          {{ video_data.engagementRate_subscriber }}%
                        </span>
                      </el-tooltip>
                    </div>
                  </div>
                  <div class="gallery_description_indicator">{{ video_data.publishedAt }}</div>
                </div>
              </li>
            </ul>
          </div>
          <div class="no-media-message" v-else>
            <img src="../../assets/post_image.png" style="opacity:0.5" alt />
            <div>{{ no_media_message }}</div>
          </div>

          <div class="pagenation-wrap" v-if="(tabs == 'summary' || tabs == 'post') && video_count > 0">
            <el-pagination @current-change="pageChange" :current-page.sync="currentPage" background layout="prev, pager, next" :total="video_count" :page-size="pagesize"></el-pagination>
          </div>

          <div class="overlay-sub" :class="[drawer ? 'overlay open' : 'overlay']" @click="drawer = false"></div>
          <div :class="[drawer ? 'media-detail-modal open' : 'media-detail-modal']">
            <div class="detail-modal" v-if="drawer">
              <div class="detail-profile-wrap">
                <div class="detail-profile-img-area">
                  <el-image class="detail-profile_img" :src="profile_data.thumbnails">
                    <div slot="error" class="data-table-profile-noimg">NO<br />IMAGE</div>
                  </el-image>
                </div>
                <div class="detail-profile-name-area">
                  <div class="detail-profile-name">{{ profile_data.channel_name }}</div>
                </div>
              </div>
              <div class="detail-img-wrap">
                <div class="detail-img-area">
                  <iframe
                    width="340"
                    height="191"
                    :src="'https://www.youtube.com/embed/' + video_data[index].video_id"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  ></iframe>
                  <div class="pr_type" v-show="video_data[index].pr_flag">
                    <div class="pr_tag">PR</div>
                  </div>
                  <div class="detail-img-load" v-show="detail_loading"></div>
                </div>
              </div>
              <div class="detail-title-area">{{ video_data[index].title }}</div>
              <div class="detail-engage-area youtube">
                <div class="detail-engage-box">
                  <span class="detail-engage">
                    <font-awesome-icon icon="eye" style="margin-right:3px" />
                    {{ video_data[index].viewCount | addComma }}
                  </span>
                  <span class="detail-engage">
                    <font-awesome-icon :icon="['far', 'comment']" style="margin-right:3px" />
                    {{ video_data[index].commentCount | addComma }}
                  </span>
                  <span class="detail-engage">
                    <font-awesome-icon icon="thumbs-up" style="margin-right:3px" />
                    {{ video_data[index].likeCount | addComma }}
                  </span>
                </div>
                <div class="detail-link">
                  <a :href="'https://www.youtube.com/watch?v=' + video_data[index].video_id" target="_blank">
                    <el-button type="info" style="margin-left:10px;">YouTube→</el-button>
                  </a>
                </div>
              </div>
              <div class="divider-nomargin"></div>
              <div class="detail-caption-area">
                <pre
                  class="caption-in"
                  v-html="$options.filters.searchHighlight(video_data[index].description, search_type == 'keyword' ? search_keyword : '', search_type == 'pr' ? true : false)"
                ></pre>
                <div class="detail-date">{{ video_data[index].publishedAt }}</div>
              </div>
            </div>
          </div>

          <transitionData :sns_type="'youtube'" :loading="loading" :id="channel_id" v-show="tabs == 'summary' || tabs == 'analysis'" />
          <transitionData :sns_type="'youtube_view'" :loading="loading" :id="channel_id" v-show="tabs == 'summary' || tabs == 'analysis'" />
          <transitionData :sns_type="'youtube_average'" :loading="loading" :id="channel_id" v-show="tabs == 'summary' || tabs == 'analysis'" />

          <!-- 視聴率分布 -->
          <distributionChart
            :avg_data="avg_data.vr"
            :name="profile_data.channel_name"
            :own_data="profile_data.average_viewRate_3month"
            :type="'vr'"
            :sns_type="'youtube'"
            :followers="profile_data.subscriberCount"
            v-show="tabs == 'summary' || tabs == 'analysis'"
          />

          <!-- エンゲージメント分布 -->
          <distributionChart
            :avg_data="avg_data.egr"
            :name="profile_data.channel_name"
            :own_data="profile_data.average_engagementRate_subscriber_3month"
            :type="'egr'"
            :sns_type="'youtube'"
            :followers="profile_data.subscriberCount"
            v-show="tabs == 'summary' || tabs == 'analysis'"
          />

          <!-- ノート -->
          <note
            v-if="tabs == 'note'"
            :id="channel_id"
            :sns_type="'youtube'"
            ref="note"
            @commentReactive="commentReactive"
            @statusReactive="statusReactive"
            @noteReactive="noteReactive"
            @tagReactive="tagReactive"
          />

          <div v-observe-visibility="{ callback: similarVisible }"></div>

          <div id="i-detail-similar"></div>

          <!-- 類似アカウント -->
          <similarAccount
            ref="similarAccount"
            v-if="similar_show"
            :sns_type="'youtube'"
            :similar_data="similar_data"
            @toInfluencerDetail="toInfluencerDetail"
            @toInfluencerDetailNewWindow="toInfluencerDetailNewWindow"
          />
        </div>
      </div>
    </div>
    <div class="loader-detail" v-show="!mounted || loading"></div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const showYouTubeAPI = root + "/api/search/show_youtube";
const loadSimilarAccountAPI = root + "/api/search/load_similar_youtube";
const loadListAPI = root + "/api/list/load_list";
const addInfluencerAPI = root + "/api/list/add_influencer";
const deleteInfluencerAPI = root + "/api/list/delete_influencer";
const addFavoriteAPI = root + "/api/list/add_favorite";
const pr_word =
  "sponsored by|【スポンサー】|スポンサー：|スポンサー:|(スポンサー)|（スポンサー）|(▽|▼|○|●|■|□|◆|◇|↓)スポンサー[^ぁ-ん一-龠]|【提供】|^提供:|^提供：|[^楽曲音源映像素材]提供：|[^楽曲音源映像素材]提供:|(提供)|（提供）|(▽|▼|○|●|■|□|◆|◇|↓)提供[^ぁ-ん]|(▽|▼|○|●|■|□|◆|◇|↓)PR提供[^ぁ-ん]";

import transitionData from "./transitionData";
import postSearchInput from "./postSearchInput";
import note from "./note.vue";
import distributionChart from "./detail_component/distribution_chart";
import addListDetail from "./detail_component/add_list_detail";
import otherSNS from "./other_sns.vue";
import similarAccount from "./detail_component/similar_account";
import { handleApiResponse } from "@/components/common/responseHelper";

export default {
  name: "youtuberDetail",
  components: {
    transitionData,
    postSearchInput,
    note,
    distributionChart,
    addListDetail,
    otherSNS,
    similarAccount,
  },
  beforeRouteLeave(to, from, next) {
    if (to.name.match(/youtuberDetail/i)) {
      this.$router.push({
        name: this.child == true ? this.parent_component + "_youtuberDetailDrawer" : "youtuberDetail",
        params: {
          channel_id: to.params.channel_id,
          child: this.child,
          parent_component: this.parent_component,
        },
      });
    } else if (to.name == "influencerDetail" && this.child) {
      this.$router.push({
        name: this.child == true ? this.parent_component + "_influencerDetailDrawer" : "influencerDetail",
        params: {
          account_name: to.params.account_name,
          child: this.child,
          parent_component: this.parent_component,
        },
      });
    } else {
      next();
    }
  },
  props: {
    channel_id: String,
    child: Boolean,
    parent_component: String,
    influencer_index: Number,
    default_search: Boolean,
    search_type: {
      type: String,
      default: "all",
    },
    search_keyword: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      channel_name: "",
      currentPage: 1,
      video_count: 0,
      pagesize: 28,
      profile_data: [],
      egr_data: [],
      video_data: [],
      no_media_message: "",
      list: [],
      active_list_count: "",
      sort_key: "timestamp",
      sort_period: "all",
      media_sort: "投稿日が新しい順",
      sort_similar_description: "並び替え",
      mounted: false,
      drawer: false,
      index: 0,
      loading: false,
      add_delete_loading: false,
      add_delete_index: "",
      detail_loading: false,
      img_count: 0,
      inputfocus: false,
      inputkeyword: "",
      actionId: new Date(),
      omission: true,
      search_dropdown: "",
      search_dropdown_regexp: "",
      search_dropdown_add: "",
      search_dropdown_add_regexp: "",
      get_account_name: "",
      get_account_name_post: "",
      requestId: 0,
      tabs: "summary",
      pr_regexp: "",
      similar_data: [],
      similar_show: false,
      similar_loading: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    activate() {
      return this.$store.state.activate;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    header_notification() {
      return this.$store.state.header_notification;
    },
    similar_account() {
      return this.similar_data.slice(0, 5);
    },
    /** REECH-3159: name で男女を対応づけ。片方にしか無い帯は他方を 0%・width 0 で表示。男女とも data が null の帯のみ非表示。 */
    youtubeAudienceRows() {
      const aud = this.profile_data && this.profile_data.audience;
      if (!aud || !Array.isArray(aud.female) || !Array.isArray(aud.male)) {
        return [];
      }
      const f = aud.female;
      const m = aud.male;
      const names = [];
      const seen = new Set();
      for (let i = 0; i < f.length; i++) {
        const nm = f[i].name;
        if (nm != null && !seen.has(nm)) {
          seen.add(nm);
          names.push(nm);
        }
      }
      for (let i = 0; i < m.length; i++) {
        const nm = m[i].name;
        if (nm != null && !seen.has(nm)) {
          seen.add(nm);
          names.push(nm);
        }
      }
      const findByName = (arr, name) => arr.find((x) => x.name === name);
      const emptySide = (name) => ({ name, data: 0, width: 0 });
      const rows = [];
      for (let i = 0; i < names.length; i++) {
        const name = names[i];
        const fItem = findByName(f, name);
        const mItem = findByName(m, name);
        const fOk = fItem != null && fItem.data !== null;
        const mOk = mItem != null && mItem.data !== null;
        if (!fOk && !mOk) {
          continue;
        }
        rows.push({
          name,
          female: fOk ? fItem : emptySide(name),
          male: mOk ? mItem : emptySide(name),
        });
      }
      return rows;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    /** width 0 でも .female-box.detail の min-width:1px や padding で帯が見えるのを防ぐ */
    youtubeAudienceBarStyle(side, gender) {
      const w = Number(side.width) || 0;
      if (w <= 0) {
        const zero = {
          width: "0%",
          minWidth: 0,
          maxWidth: 0,
          overflow: "hidden",
        };
        if (gender === "female") {
          return { ...zero, paddingLeft: 0, marginLeft: 0 };
        }
        return { ...zero, paddingRight: 0, marginRight: 0 };
      }
      return { width: w + "%" };
    },
    isMissingNumber(val) {
      return val === null || val === undefined || val === '' || isNaN(Number(val));
    },

    formatViewCountNumber(val) {
      if (val === null || val === undefined || val === '' || isNaN(val)) return '0';
      const num = Number(val);

      // 1万以下：整数
      if (num <= 9999) return String(Math.floor(num));

      // 1万超え：万表記（小数1桁、.0削除）
      let man = num / 10000;
      let str = man.toFixed(1);
      if (str.endsWith('.0')) str = str.slice(0, -2);
      return str;
    },
    formatViewCountUnit(val) {
      if (val === null || val === undefined || val === '' || isNaN(val)) return '回';
      const num = Number(val);
      return num <= 9999 ? '回' : '万回';
    },
    load() {
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      this.loading = true;
      if (this.default_search == true) {
        this.search_type = this.$route.params.search_type;
        this.search_keyword = this.$route.params.search_keyword;
        this.searchMedia(this.search_type, this.search_keyword);
        this.loadList();
      } else {
        this.axios
          .get(showYouTubeAPI, {
            requestId: this.requestId,
            params: {
              token: this.token,
              channel_id: this.channel_id,
              search_type: "all",
            },
          })
          .then((response) => {
            if (handleApiResponse(response)) {
              // ステータスがNGの場合
              this.$message.error(response.data.message);
              this.$nextTick(() => {
                this.$router.push({ name: 'youtuber' }); // youtuberルートへ遷移
              });
              return;
            }
            // ステータスがOKの場合
            this.mounted = true;
            this.profile_data = response.data.profile_data;
            this.avg_data = response.data.avg_data;
            this.video_data = response.data.video_data;
            this.video_count = response.data.video_count;
            this.video_count == 0 ? (this.loading = false) : "";
            this.loadSimilarAccount();
          })
          .catch(() => {
            // ネットワークエラーその他の例外処理
            this.$message.error("サーバーとの通信でエラーが発生しました");
            this.$nextTick(() => {
              this.$router.push({ name: 'youtuber' }); // youtuberルートへ遷移
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    loadSimilarAccount() {
      this.axios.cancel(this.requestId_similar);
      this.requestId_similar += 1;
      this.similar_loading = true;
      this.axios
        .get(loadSimilarAccountAPI, {
          requestId: this.requestId_similar,
          params: {
            token: this.token,
            channel_id: this.channel_id,
          },
        })
        .then((response) => {
          this.similar_data = response.data.similar_data;
          this.similar_loading = false;
        })
        .catch(() => {});
    },
    similarVisible(isVisible) {
      if (isVisible && !this.similar_show) {
        this.similar_show = true;
      }
    },
    loadList() {
      this.axios
        .get(loadListAPI, {
          params: {
            token: this.token,
            type: "min",
            sns_type: "youtube",
            influencer: this.profile_data.channel_id,
          },
        })
        .then((response) => {
          this.list = response.data.mylist;
          this.active_list_count = response.data.active_list_count;
        });
    },
    addInfluencer(id, name, index) {
      this.add_delete_loading = true;
      this.add_delete_index = index;
      const channel_id = this.profile_data.channel_id;
      const channel_id_js = [channel_id];
      var params = new URLSearchParams();
      params.append("list_id", id);
      params.append("influencer", JSON.stringify(channel_id_js));
      params.append("sns_type", "youtube");
      params.append("token", this.token);
      this.axios.post(addInfluencerAPI, params).then(() => {
        this.add_delete_loading = false;
        this.profile_data.list_count += 1;
        this.$refs.add_list_detail.loadList();
        this.$emit("loadFromDetail", id);
        this.$emit("addInfluencerReactive", this.influencer_index, name, id);
        this.checkList = [];
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: this.profile_data.channel_name + "を" + name + "に追加しました",
        });
        this.$store.dispatch("loadSidemenuOption", this.token);
        if (this.tabs == "note") {
          this.$refs.note.loadNote(false);
        }
      });
    },
    deleteInfluencer(id, name, index) {
      this.add_delete_loading = true;
      this.add_delete_index = index;
      const channel_id = this.profile_data.channel_id;
      const channel_id_js = [channel_id];
      var params = new URLSearchParams();
      params.append("list_id", id);
      params.append("sns_type", "youtube");
      params.append("influencer", JSON.stringify(channel_id_js));
      params.append("token", this.token);
      this.axios.post(deleteInfluencerAPI, params).then(() => {
        this.add_delete_loading = false;
        this.profile_data.list_count -= 1;
        this.$refs.add_list_detail.loadList();
        this.$emit("loadFromDetail", id);
        this.$emit("deleteInfluencerReactive", this.influencer_index, id);
        this.checkList = [];
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: this.profile_data.channel_name + "を" + name + "から削除しました",
        });
        if (this.tabs == "note") {
          this.$refs.note.loadNote(false);
        }
      });
    },
    pageChange(currentPage) {
      this.loading = true;
      this.currentPage = currentPage;
      this.video_data = [];
      this.requestId += 1;
      this.axios
        .get(showYouTubeAPI, {
          requestId: this.requestId,
          params: {
            token: this.token,
            channel_id: this.channel_id,
            currentPage: this.currentPage,
            search_type: this.search_type,
            search_keyword: this.search_keyword,
            sort_key: this.sort_key,
            sort_period: this.sort_period,
          },
        })
        .then((response) => {
          if (handleApiResponse(response)) {
            // ステータスがNGの場合
            this.$message.error(response.data.message);
            this.$nextTick(() => {
              this.$router.push({ name: 'youtuber' }); // youtuberルートへ遷移
            });
            return;
          }
          this.profile_data = response.data.profile_data;
          this.avg_data = response.data.avg_data;
          this.video_data = response.data.video_data;
          this.video_count = response.data.video_count;
          this.video_count == 0 ? (this.loading = false) : "";
          var element = document.getElementById("i-detail-wrap");
          element.scroll({
            top: 0,
            behavior: "instant",
          });
          this.actionId += 1;
        });
    },
    searchMedia(type, keyword) {
      this.loading = true;
      this.click_loading = true;
      this.currentPage = 1;
      this.tabs = "post";
      if (this.search_type != type || this.search_keyword != keyword) {
        this.media_sort = "投稿日が新しい順";
        this.sort_key = "timestamp";
        this.sort_period = "all";
      }
      if (type !== "keyword") this.inputkeyword = "";
      if (type == "keyword" && keyword == "") type = "all";
      this.search_type = type;
      this.search_keyword = keyword;
      this.requestId += 1;
      this.video_data = [];
      this.axios
        .get(showYouTubeAPI, {
          requestId: this.requestId,
          params: {
            token: this.token,
            channel_id: this.channel_id,
            currentPage: 1,
            search_type: this.search_type,
            search_keyword: this.search_keyword,
            sort_key: this.sort_key,
            sort_period: this.sort_period,
          },
        })
        .then((response) => {
          if (handleApiResponse(response)) {
            // ステータスがNGの場合
            this.$message.error(response.data.message);
            this.$nextTick(() => {
              this.$router.push({ name: 'youtuber' }); // youtuberルートへ遷移
            });
            return;
          }
          if (response.data.video_count == 0) {
            this.no_media_message = response.data.no_media_message;
            this.loading = false;
          }
          this.mounted = true;
          this.profile_data = response.data.profile_data;
          this.avg_data = response.data.avg_data;
          this.video_data = response.data.video_data;
          this.video_count = response.data.video_count;
          this.video_count == 0 ? (this.loading = false) : "";
          this.loadSimilarAccount();
          if (this.search_type == "pr") this.pr_regexp = response.data.search_word;
          var element = document.getElementById("i-detail-wrap");
          element.scroll({
            top: 0,
            behavior: "instant",
          });
          this.actionId += 1;
        });
    },
    sortMediaBy(sort_key, sort_period, sort_description) {
      this.sort_key = sort_key;
      this.sort_period = sort_period;
      this.media_sort = sort_description;
      this.searchMedia(this.search_type, this.search_keyword);
    },
    resetSearchMedia() {
      this.search_type = "all";
      this.search_keyword = "";
      this.sort_key = "timestamp";
      this.sort_period = "all";
      this.media_sort = "投稿日が新しい順";
      this.inputkeyword = "";
      this.currentPage = 1;
    },
    detail(index) {
      (this.drawer = true), (this.index = index);
      this.detail_loading = true;
      this.actionId += 1;
    },
    favorite() {
      if (this.profile_data.favorite == 0) {
        this.profile_data.favorite = 1;
      } else {
        this.profile_data.favorite = 0;
      }
      var params = new URLSearchParams();
      params.append("influencer", this.profile_data.ig_id);
      params.append("sns_type", "youtube");
      params.append("favorite", this.profile_data.favorite);
      params.append("token", this.token);
      this.axios.post(addFavoriteAPI, params);
      this.$emit("favoriteReactive", this.influencer_index, this.profile_data.favorite);
    },
    imgLoaded() {
      //imgErrorと併せて読み込み画像数をカウントし、全画像読み込み時にローディング解除
      this.img_count += 1;
      if (this.img_count == this.video_data.length) {
        this.loading = false;
        this.detail_loading = false;
        this.img_count = 0;
      }
    },
    imgError(index) {
      this.video_data[index].img_error = true;
      this.img_count += 1;
      if (this.img_count == this.video_data.length) {
        this.loading = false;
        this.detail_loading = false;
        this.img_count = 0;
      }
    },
    toSetting() {
      this.$router.push("/setting");
    },
    closeParentDrawer() {
      this.drawer = false;
    },
    closeParentDrawerClear() {
      this.resetSearchMedia();
      this.loading = true;
    },
    openParentDrawer() {
      this.child = true;
    },
    searchDropdown(value) {
      this.search_dropdown_regexp = new RegExp(value, "ig");
    },
    searchDropdownAdd(value) {
      this.search_dropdown_add_regexp = new RegExp(value, "ig");
    },
    scrollBottom() {
      if (this.shimilar_show) {
        document.getElementById("i-detail-similar").scrollIntoView({ block: "start", behavior: "smooth" });
      } else {
        this.similar_show = true;
        setTimeout(() => {
          document.getElementById("i-detail-similar").scrollIntoView({ block: "start", behavior: "smooth" });
        }, 100);
      }
    },
    openYouTube() {
      let url = "https://www.youtube.com/channel/" + this.channel_id;
      window.open(url, "_blank");
    },
    changeTab(tab) {
      this.loading = true;
      if (this.tabs == "post" && tab != "post" && (this.search_type != "all" || this.sort_period != "all")) {
        this.resetSearchMedia();
        this.searchMedia("all", "");
        this.tabs = tab;
      } else {
        setTimeout(() => {
          this.tabs = tab;
          var element = document.getElementById("i-detail-wrap");
          element.scroll({
            top: 0,
            behavior: "instant",
          });
          this.loading = false;
        }, 0);
      }
    },
    commentReactive(comment, list_id) {
      this.$emit("commentReactive", this.channel_id, comment, list_id);
    },
    statusReactive(status, list_id) {
      this.$emit("statusReactive", this.channel_id, status, list_id);
    },
    noteReactive(note_info, property_name) {
      this.$emit("noteReactive", this.channel_id, note_info, property_name);
    },
    tagReactive(type, tag_index, new_tag) {
      this.$emit("tagReactive", this.channel_id, type, tag_index, new_tag);
    },
    toInfluencerDetail(channel_id) {
      this.$router.push({
        name: this.child == true ? this.parent_component + "_youtuberDetailDrawer" : "youtuberDetail",
        params: {
          channel_id: channel_id,
          child: this.child == true ? true : false,
          parent_component: this.parent_component,
        },
      });
    },
    toInfluencerDetailNewWindow(channel_id) {
      let routeData = this.$router.resolve({
        name: "youtuberDetail",
        params: {
          channel_id: channel_id,
          child: false,
        },
      });
      window.open(routeData.href, "_blank");
    },
    averageLikeFormat(val) {
      if (val === null || val === undefined || val === '' || isNaN(val)) {
        return 0;
      }
      const num = Number(val);
      if (num < 10000) {
        return Math.round(num);
      }
      let man = num / 10000;
      let str = man.toFixed(1);
      if (str.endsWith('.0')) {
        str = str.slice(0, -2);
      }
      return str;
    },
  },
  filters: {
    searchHighlight(value, keyword, pr) {
      const url_regexp = /https?:\/\/[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#\u3000-\u30FE\u4E00-\u9FA0\uFF01-\uFFE3]+/g;
      if (keyword) {
        const keyword_rep1 = keyword.replace(/OR/g, "|");
        const keyword_rep2 = keyword_rep1.replace(/"/g, "");
        const keyword_rep3 = keyword_rep2.replace(/\s/g, "|");
        const keyword_RegExp = new RegExp(keyword_rep3, "ig");
        var return_value = value.replace(keyword_RegExp, (keyword) => '<span class="data-table-th-highlight">' + keyword + "</span>");
      } else if (pr == true) {
        var pr_regexp = pr_word;
        const keyword_RegExp = new RegExp(pr_regexp, "ig");
        return_value = value.replace(keyword_RegExp, (keyword) => '<span class="data-table-th-highlight">' + keyword + "</span>");
      } else {
        return_value = value;
      }
      return return_value.replace(url_regexp, (url) => '<a class="router-link" href="' + url + '" target="_blank">' + url + "</a>");
    },
    growthrate(val) {
      if (val == null) {
        return "NA";
      } else {
        return val;
      }
    },
    viewcount(val) {
      if (val >= 9999) {
        return Math.floor(val / 1000) / 10;
      } else {
        return val;
      }
    },
    addComma(val) {
      return Math.floor(val).toLocaleString();
    },
  },
  watch: {
    actionId() {
      this.$forceUpdate();
    },
    $route() {
      this.load();
      this.closeParentDrawerClear();
      this.child = true;
    },
    currentPage() {
      if (this.currentPage > 1) this.tabs = "post";
    },
  },
};
</script>

<style scoped>
.profile_follower {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}

.profile_num {
  width: 25% !important;
  padding: 10px;
  box-sizing: border-box;
  margin: 0 !important;
}

.reel_average_video_play_count {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
}

.reel_num_total .num {
  font-size: 18px;
  line-height: 1.1;
}

.reel_num_total .unit-compact {
  font-size: 10px;
  color: #666;
  line-height: 1;
}

.num_bar {
  width: 100%;
  margin: 3px 0 0;
}

.avg_view_count .reel_num_total .num {
  font-size: 16.5px;
  line-height: 1.1;
}

.avg_view_count .reel_num_total .unit-compact {
  font-size: 7px;
  color: #666;
  line-height: 1;
}
</style>